/* eslint-disable no-nested-ternary */
/* eslint-disable no-param-reassign */
import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'
import {useSelector} from 'react-redux'

export async function uploadImg(params) {
  const resp = await http.post('/live/misc/upload_img', {
    ...params,
    ...window.store.getState().env.deviceinfo,
  })
  return resp.data.data
}

export const activity_honor_homepage = createAsyncThunk(
  'RaceHonorWall/activity_honor_homepage',
  async (p: any, store: any) => {
    const {
      deviceinfo,
      otherInfo: {mid},
    } = store.getState().env
    const resp = await http.post(
      '/live/privilege/activity_honor_homepage',
      {
        mid: mid || deviceinfo.h_m,
        ...p,
      },
      {store}
    )
    return resp.data.data
  }
)

const initialState: {
  home: any
} = {
  home: {},
}

export const RaceHonorWallSlice = createSlice({
  name: 'RaceHonorWall',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(activity_honor_homepage.fulfilled, (state, action) => {
      const {year_list = []} = action.payload
      Object.assign(state, {
        home: {
          ...action.payload,
          year_list: year_list?.reverse(),
        },
      })
    })
  },
})

export const useRaceHonorWall = () =>
  useSelector((store) => store.RaceHonorWall)

export default RaceHonorWallSlice.reducer
export const RaceHonorWallActions = RaceHonorWallSlice.actions
